import React from 'react';
import {Text} from '@/ui-kits';

interface StepCardProps {
  stepNumber: number;
  title: string;
  description: string | React.ReactNode;
}

// Step card with: (1) vertical bottom gradient on the card, (2) diagonal gradient on the step circle
export const StepCard: React.FC<StepCardProps> = ({stepNumber, title, description}) => {
  // Diagonal gradient classes for the numbered circle
  const circleGradients: Record<number, string> = {
    1: 'bg-gradient-to-br from-blue-400/70 via-blue-500 to-blue-600',
    2: 'bg-gradient-to-br from-yellow-200/80 via-yellow-300 to-yellow-400',
    3: 'bg-gradient-to-br from-orange-300/80 via-orange-400 to-orange-500',
    4: 'bg-gradient-to-br from-green-400/80 via-green-500 to-green-600',
  };

  return (
    <div className="relative rounded-lg sm:rounded-xl shadow-sm border border-gray-200 overflow-hidden h-full bg-white">
      {/* Bottom gradient: middle faint → bottom dark */}
      <div className="absolute inset-x-0 bottom-0 h-[58%] bg-gradient-to-b from-ui_frost_blue/20 via-ui_frost_blue/60 to-ui_frost_blue rounded-b-lg sm:rounded-b-xl" />

      {/* Content above the background */}
      <div className="relative z-10 p-2 flex flex-col gap-3 sm:gap-4 h-full">
        <div className="flex items-center justify-start">
          <div className={`w-10 h-10 sm:w-12 sm:h-12 rounded-full ${circleGradients[stepNumber]} flex items-center justify-center flex-shrink-0`}>
            <Text variant="headingSemiBold" className="text-white text-lg sm:text-xl">
              {stepNumber}
            </Text>
          </div>
        </div>

        <div className="flex flex-col gap-2 flex-grow">
          <div className="">
            <Text variant="subtitle" className="text-ui_blue font-FigtreeSemiBold font-semibold leading-tight">{title}</Text>
          </div>
          <Text variant="body" className="text-ui_input_border_dark leading-relaxed">{description}</Text>
        </div>
      </div>
    </div>
  );
};